import { render, staticRenderFns } from "./urgent.vue?vue&type=template&id=8d1789bc&scoped=true&"
import script from "./urgent.vue?vue&type=script&lang=js&"
export * from "./urgent.vue?vue&type=script&lang=js&"
import style0 from "./urgent.vue?vue&type=style&index=0&id=8d1789bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1789bc",
  null
  
)

export default component.exports